import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';

export const Title = styled.h1`
    color: ${cssVars.fg_gray2_white};
    margin: 34px 0 24px;
    color: ${cssVars.fg_gray1_white};
    ${Text.Mobile.heading2};

    ${Screen.ipad} {
        ${Text.Ipad.heading3};
        margin: 54px 0 24px;
    }

    ${Screen.desktop} {
        ${Text.Desktop.heading2};
    }
`;

export const CardsGrid = styled.div`
    display: grid;
    gap: 10px;
    margin-bottom: 50px;

    ${Screen.ipad} {
        grid-template-columns: 1fr 1fr;
    }

    ${Screen.desktop} {
        grid-template-columns: repeat(3, 1fr);
        gap: 24px;
        margin-bottom: 60px;
    }
`;
